/**
 * TextHighlighterService is a service class that manages text highlights.
 * It allows saving and retrieving highlights using unique identifiers.
 */
class TextHighlighterService {
    /**
     * Constructs a new TextHighlighterService instance.
     * @param {Object} $rootScope - The root scope object from AngularJS.
     */
    constructor($rootScope) {
        this.$rootScope = $rootScope;
        this._highlights = {}; // Stores highlights by their unique IDs.
    }

    /**
     * Saves a highlight with a given ID.
     * @param {string} id - The unique identifier for the highlight.
     * @param {Object} json - The JSON object representing the highlight.
     * @returns {TextHighlighterService} The current instance of the service.
     */
    saveHighlight(id, json) {
        this._highlights[id] = json;
        return this;
    }

    /**
     * Retrieves all saved highlights.
     * @returns {Object} An object containing all highlights, keyed by their IDs.
     */
    getHighlights() {
        return this._highlights;
    }
}

export default TextHighlighterService;